import React from 'react';
import './App.css';
import InsuranceChecker from './containers/InsuranceChecker';
import Box from '@mui/material/Box';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';

function App () {
    return (
        <ThemeProvider theme={theme}>
            <Box>
                <InsuranceChecker/>
            </Box>
        </ThemeProvider>
    );
}

export default App;
